import React from 'react';
import styles from '../ReportCard.module.scss';

/**
 * Компонент пагинации (первая / назад / вперёд / последняя).
 */
const Pagination = ({ page, setPage, count, hasNext, hasPrev, pageSize = 10, shownCount, style }) => {
  const totalPages = Math.ceil(count / pageSize);

  return (
    <div className={styles.paginationContainer} style={style}>
      <div className={styles.paginationButtons}>
        <button
          onClick={() => setPage(1)}
          disabled={page === 1}
          title="Первая страница"
          className={styles.paginationBtnFirst}
        >
          ⏮ Первая
        </button>
        <button
          onClick={() => setPage(p => Math.max(1, p - 1))}
          disabled={!hasPrev || page === 1}
          className={styles.paginationBtnPrev}
        >
          ← Назад
        </button>
        <span className={styles.paginationText}>
          Страница {page} {totalPages > 0 ? `из ${totalPages}` : ''}
        </span>
        <button
          onClick={() => setPage(p => p + 1)}
          disabled={!hasNext}
          className={styles.paginationBtnNext}
        >
          Вперёд →
        </button>
        <button
          onClick={() => { if (totalPages > 0) setPage(totalPages); }}
          disabled={!hasNext || page === totalPages}
          title="Последняя страница"
          className={styles.paginationBtnLast}
        >
          Последняя ⏭
        </button>
      </div>
      <div className={styles.paginationInfo}>
        Показано {shownCount} из {count} записей
      </div>
    </div>
  );
};

export default React.memo(Pagination);
